import { Box, HStack, Stack } from "@chakra-ui/react";
import RecordTargetField, { ShowRecordTarget } from "features/Resources/Shared/Components/Fields/RecordTargetField";
import { FloatingField } from "design-system";
import { UseFormReturn } from "react-hook-form";
import { TaskTemplate } from "features/Resources/TaskTemplate/models";
import { PrimaryButton, SecondaryButton } from "components/Button";
import { useTaskActionContext } from "contexts/TaskActionContext";
import { Text16 } from "components/Text";
import { ShowRichText } from "components/FormElements/Fields/RichTextAreaField";

interface MessagePromptFormProps {
  form: UseFormReturn<TaskTemplate>;
}

export default function TaskTemplateMessagePromptForm({ form }: MessagePromptFormProps) {
  const { control, trigger, resetField } = form;
  const { onClose } = useTaskActionContext();

  const handleValidate = async () => {
    const isValid = await trigger(["messageRecipient", "messageBody"]);
    if (isValid) {
      onClose();
    }
  };

  const handleClose = () => {
    resetField("messageRecipient");
    resetField("messageBody");
    onClose();
  };
  return (
    <Stack gap="2">
      <Box mb="2">
        <Text16>The task assignee will be prompted to send this message to the user / channel selected below.</Text16>
      </Box>
      <RecordTargetField label="Message Recipient" fieldName="messageRecipient" form={form} recordTargetTypes="All" />
      <FloatingField name="messageBody">
        <FloatingField.Label>Message</FloatingField.Label>
        <FloatingField.Trix control={control} name="messageBody" includePersonalize actionType="message" alwaysShowToolbar />
      </FloatingField>
      <HStack justify="flex-end">
        <SecondaryButton onClick={handleClose}>Close</SecondaryButton>
        <PrimaryButton onClick={handleValidate}>Add</PrimaryButton>
      </HStack>
    </Stack>
  );
}

interface DisplayPrebuiltTaskTemplateMessagePromptProps {
  prebuiltTaskTemplate: TaskTemplate;
}

export function DisplayPrebuiltTaskTemplateMessagePrompt({
  prebuiltTaskTemplate,
}: DisplayPrebuiltTaskTemplateMessagePromptProps) {
  const { onClose } = useTaskActionContext();
  return (
    <Stack gap="2">
      <Box mb="2">
        <Text16>The task assignee will be prompted to send this message to the user / channel below.</Text16>
      </Box>
      <ShowRecordTarget recordTarget={prebuiltTaskTemplate?.messageRecipient} label="Message Recipient" />
      <ShowRichText label="Message" richText={prebuiltTaskTemplate?.messageBody} />
      <HStack justify="flex-end">
        <PrimaryButton onClick={onClose}>Close</PrimaryButton>
      </HStack>
    </Stack>
  );
}
